import * as React from "react";
import { List } from "immutable";
import Face from "../face";
import DieFaceDisplay from "./dieFaceDisplay";
import * as Selector from "../selector";
import State from "../model";
import { Dispatch } from "redux";
import { AppAction } from "../actions";
import { connect } from "react-redux";
import { Row, Col } from "react-bootstrap";
import { StateWithHistory } from "redux-undo";

interface RollProps {
    shownFaces: List<Face>
}

class RollPropsDisplay extends React.Component<RollProps, {}> {
    public render(): JSX.Element {
        return <Row>
            <Col key={-1} xs={2} />
            {this.props.shownFaces.map((face, i) => <Col xs={2} key={i}><DieFaceDisplay currentRoll={true} selectedRoll={false} key={i} face={face} dieIndex={i} /></Col>)}
        </Row>;
    }
}

const mapStateToProps = (state: StateWithHistory<State>, ownProps: {}) => {
    return { shownFaces: Selector.getRolledFaces(state.present) }
}

const mapDispatchToProps = (dispatch: Dispatch<AppAction>) => ({ });

export default connect(mapStateToProps, mapDispatchToProps)(RollPropsDisplay);
